import { useLocalization } from '@ais-ui/locale-management';
import { TargetForm } from './TargetForm';
import { UseFormReturn } from 'react-hook-form';
import { TargetFormValues } from './useTargetForm';

interface SettingsTargetPageProps {
  form: UseFormReturn<TargetFormValues>;
}

export function SettingsTargetPage({ form }: SettingsTargetPageProps) {
  const { messages } = useLocalization();

  return <TargetForm form={form} />;
}
